<template>
    <div>
        <van-nav-bar left-arrow title="切换科目" @click-left="onClickLeft" @click-right="onClickRight" fixed='true'
            placeholder="true" />
        <div class="menuList">
            <div class="menuList_fg"></div>
            <div class="boxMenuList" v-for="(item, index) in menuListData" :key="index">
                <div class="boxMenuList_title">{{ item.KsbClassName }}</div>
                <div class="box_Child">
                    <div v-for="(items, indexs) in item.Childs" :key="indexs" class="box_Childs">
                        <div class="box_Childs_a">
                            <img :src="items.url " alt="">
                        </div>
                        <div class="box_Childs_b" catchtap="clickChilds">
                            <div class="Childs_CName">{{ items.CName }}</div>
                            <div class="Childs_appCode">{{ items.appCode }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { menuList, saveAppID, login } from "../api/api";
export default {
    data() {
        return {
            menuListData: [],
            childsData: [],

        }
    },
    created() {
       
        var loginData = JSON.parse(localStorage.getItem('loginData'))
        var datas = {
            appEName: loginData.appEName,
            guid: loginData.guid,
            userID: loginData.userID,
        }
        menuList(datas).then(res => {
            console.log('kkkkk', res)
            this.menuListData = res.data.data,
                this.childsData = res.data.data[0].Childs[0]
        })
    },
    mounted() {
        
    },
    methods: {
        onClickRight(){
            // this.$router.push({ path: '/home/first' })
        }
    },
}
</script>
<style scoped>
.sidebarBox .van-sidebar-item {
    width: 100px;
    padding: 20px 0;
    background-color: #fff;
    padding-left: 5px;
}

.sidebarBox .van-sidebar-item--selected {
    border-color: #FFDB00;
}

.sidebarBox .van-sidebar-item--selected,
.sidebarBox .van-sidebar-item--selected.van-sidebar-item--hover {
    background-color: #F7F8FA;
    color: #FFDB00;
}

.box {
    display: flex;
    height: 100vh;
    background-color: #F7F8FA;
}

.box_sidebar {
    width: 100px;
    height: 100vh;
}

.menuListChilds {
    width: 225px;
    height: 100vh;
}

.menuListChildsA {
    width: 90%;
    text-align: center;
    margin: 0 auto;
    margin-top: 10px;
    padding: 8px 0;
    background-color: #fff;
    border-radius: 4px;
    font-size: 15px;
}

.menuListChildsTitle {
    width: 90%;
    margin: 0 auto;
    font-size: 15px;
    padding-top: 19px;
    font-weight: 600;
}

.menuList {
    height: 100vh;
    background-color: #F8F8FA;
    overflow-y: auto;
}

.boxMenuList {
    padding: 0px 15px;
    padding-top: 5px;
}

.menuList_fg {
    padding-top: 10px;
}

.boxMenuList_title {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    margin-bottom: 10px;
}

.box_Childs {
    width: 48%;
    height: 64px;
    background-color: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(133, 149, 181, 0.1);
    margin-bottom: 14px;
    border-radius: 5px;
    display: flex;
    align-items: center;

}

.Childs_CName {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

.box_Child {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.box_Childs_a {
    width: 30%;
    text-align: center;
    line-height: 75px;
}

.box_Childs_a img {
    width: 28px;
    height: 23px;
    text-align: center;
    vertical-align: middle;
}

.box_Childs_b {
    width: 70%;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 500;
    color: #000000;
}

.Childs_appCode {
    display: flex;
    justify-content: flex-start;
    font-size: 12px;
    color: #666666;
}
</style>